var map = {
	"./add.svg": "37ac",
	"./block.svg": "9cd1",
	"./bookmark.svg": "b81e",
	"./box.svg": "ac5a",
	"./calendar.svg": "b4d9",
	"./chat.svg": "a18f",
	"./clipboard.svg": "30c0",
	"./compass.svg": "7ca6",
	"./copy.svg": "0876",
	"./crosshair.svg": "6193",
	"./edit.svg": "6327",
	"./filter.svg": "789f",
	"./focus.svg": "b5ab",
	"./hint.svg": "6ec1",
	"./layers.svg": "b1ac",
	"./lock.svg": "bfc6",
	"./marker.svg": "d458",
	"./markerarrows.svg": "5ed9",
	"./mask.svg": "0fa8",
	"./moon.svg": "403f",
	"./more.svg": "b3e6",
	"./mug.svg": "c6ac",
	"./nohands.svg": "f2e4",
	"./open.svg": "00fb",
	"./reload.svg": "5ffe",
	"./right-arrow.svg": "8cee",
	"./save.svg": "9297",
	"./search.svg": "6e87",
	"./settings.svg": "c024",
	"./square.svg": "bede",
	"./sun.svg": "ee49",
	"./tag.svg": "1e94",
	"./trash.svg": "457b",
	"./virus.svg": "2047",
	"./viruslogo.svg": "3054",
	"./zoom-in.svg": "68a5",
	"./zoom-out.svg": "d1e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72d8";